// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-simple-layout {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  overflow: hidden;
  background: radial-gradient(circle at top right, rgba(59, 130, 246, 0.08), transparent 32%), linear-gradient(180deg, #f8fbff 0%, #f1f5f9 100%);
}

.user-simple-layout__topbar {
  height: 5.625rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem 0 0.9rem;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
}

.user-simple-layout__brand {
  display: flex;
  align-items: center;
  gap: 1rem;
  min-width: 0;
}

.user-simple-layout__logo {
  display: block;
  width: 10rem;
  height: auto;
}

.user-simple-layout__divider {
  width: 1px;
  height: 2.4rem;
  background: #d7e2ef;
  flex: 0 0 auto;
}

.user-simple-layout__workspace-meta {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  max-width: clamp(10rem, 28vw, 18rem);
}

.user-simple-layout__workspace-title {
  color: #0f2744;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-simple-layout__profile {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  color: #475569;
  font-size: 0.95rem;
  font-weight: 500;
  white-space: nowrap;
}

.top-nav-actions {
  display: flex;
  align-items: center;
  gap: 22px;
}

.user-simple-layout__profile ejs-tooltip {
  display: inline-flex;
  align-items: center;
}

.user-simple-layout__greeting {
  color: #64748b;
}

.user-simple-layout__profile .top-nav-action-btn,
.user-simple-layout__profile .top-nav-action-btn.e-btn,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn.e-btn {
  width: 42px;
  min-width: 42px;
  height: 42px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #7b8491;
  box-shadow: none;
  line-height: 1;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;
}

.user-simple-layout__profile .top-nav-action-btn.user-simple-layout__nav-icon-button--active,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn.user-simple-layout__nav-icon-button--active {
  border: 1px solid #cfe3ff;
}

.user-simple-layout__profile .top-nav-action-btn:hover,
.user-simple-layout__profile .top-nav-action-btn:focus-visible,
.user-simple-layout__profile .top-nav-action-btn.user-simple-layout__nav-icon-button--active,
.user-simple-layout__profile .top-nav-action-btn.e-btn:hover,
.user-simple-layout__profile .top-nav-action-btn.e-btn:focus-visible,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn:hover,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn:focus-visible,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn.user-simple-layout__nav-icon-button--active,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn.e-btn:hover,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn.e-btn:focus-visible {
  border-color: #cfe3ff;
  background: #eef6ff;
  color: #0066ff;
  outline: none;
  box-shadow: none;
}

.top-nav-svg-icon,
:host ::ng-deep .user-simple-layout__profile .top-nav-svg-icon {
  width: 24px;
  height: 24px;
  display: block;
  object-fit: contain;
  opacity: 0.82;
  filter: grayscale(1) saturate(0) brightness(0) opacity(0.62);
}

.top-nav-action-btn:hover .top-nav-svg-icon,
.top-nav-action-btn:focus-visible .top-nav-svg-icon,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn:hover .top-nav-svg-icon,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn:focus-visible .top-nav-svg-icon {
  opacity: 1;
  filter: invert(34%) sepia(96%) saturate(2870%) hue-rotate(207deg) brightness(101%) contrast(104%);
}

.user-simple-layout__profile .top-nav-action-icon,
.user-simple-layout__profile .top-nav-action-btn .e-icons,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-icon,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn .e-icons {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: currentColor;
  font-size: 24px;
  line-height: 24px;
}

.user-simple-layout__nav-feather-icon,
:host ::ng-deep .user-simple-layout__profile .top-nav-action-icon svg {
  stroke: currentColor;
}

:host ::ng-deep .user-simple-layout__nav-feather-icon svg {
  width: 23px;
  height: 23px;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.user-simple-layout__nav-svg-icon {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.user-simple-layout__billing-icon {
  transform: translateY(0.1rem);
}

.api-key-drawer-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1040;
  background: rgba(15, 23, 42, 0.32);
}

.api-key-drawer {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1041;
  display: flex;
  flex-direction: column;
  width: min(28.75rem, 100vw);
  height: 100vh;
  padding: 1.5rem;
  border-left: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: -20px 0 48px rgba(15, 23, 42, 0.18);
  transform: translateX(100%);
  transition: transform 0.24s ease;
  pointer-events: none;
}

.api-key-drawer--open {
  transform: translateX(0);
  pointer-events: auto;
}

.api-key-drawer__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid #e2e8f0;
}

.api-key-drawer__title {
  margin: 0;
  color: #0f172a;
  font-size: 1.15rem;
  font-weight: 700;
}

.api-key-drawer__description,
.api-key-drawer__helper {
  margin: 0.45rem 0 0;
  color: #64748b;
  font-size: 0.86rem;
  line-height: 1.45;
}

.api-key-drawer__close,
.api-key-drawer__edit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dbe3ec;
  background: #ffffff;
  color: #475569;
}
.api-key-drawer__close:hover, .api-key-drawer__close:focus-visible,
.api-key-drawer__edit:hover,
.api-key-drawer__edit:focus-visible {
  border-color: #b8c7d7;
  background: #f8fafc;
  color: #004d80;
  outline: none;
}

.api-key-drawer__close {
  width: 2rem;
  height: 2rem;
  border-radius: 0.55rem;
  font-size: 1.25rem;
  line-height: 1;
}

.api-key-drawer__content {
  padding-top: 1.5rem;
}

.api-key-drawer__section-title {
  margin: 0 0 1rem;
  color: #1e293b;
  font-size: 0.95rem;
  font-weight: 700;
}

.api-key-drawer__label {
  display: block;
  margin-bottom: 0.4rem;
  color: #334155;
  font-size: 0.82rem;
  font-weight: 700;
}

.api-key-drawer__input {
  width: 100%;
  height: 2.65rem;
  padding: 0 0.8rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.55rem;
  color: #0f172a;
  font-size: 0.92rem;
  outline: none;
}
.api-key-drawer__input:focus {
  border-color: #004d80;
  box-shadow: 0 0 0 3px rgba(0, 77, 128, 0.12);
}
.api-key-drawer__input[aria-invalid=true] {
  border-color: #dc2626;
}

.api-key-drawer__error {
  margin: 0.45rem 0 0;
  color: #dc2626;
  font-size: 0.78rem;
  font-weight: 600;
}

.api-key-drawer__summary {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.8rem;
  border: 1px solid #dbe3ec;
  border-radius: 0.7rem;
  background: #f8fafc;
}

.api-key-drawer__masked-key {
  flex: 1 1 auto;
  min-width: 0;
  color: #0f172a;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", monospace;
  font-size: 0.9rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.api-key-drawer__edit {
  flex: 0 0 auto;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
}
.api-key-drawer__edit i-feather {
  width: 0.95rem;
  height: 0.95rem;
}

.api-key-drawer__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.5rem;
}

.api-key-drawer__button {
  min-width: 5rem;
  height: 2.35rem;
  padding: 0 1rem;
  border: 1px solid #cbd5e1;
  border-radius: 0.55rem;
  background: #ffffff;
  color: #334155;
  font-size: 0.86rem;
  font-weight: 700;
}
.api-key-drawer__button:hover, .api-key-drawer__button:focus-visible {
  background: #f8fafc;
  outline: none;
}

.api-key-drawer__button--primary {
  border-color: #004d80;
  background: #004d80;
  color: #ffffff;
}
.api-key-drawer__button--primary:hover, .api-key-drawer__button--primary:focus-visible {
  background: #003f69;
}

.user-simple-layout__content {
  flex: 1 1 auto;
  min-height: 0;
  padding: 1.15rem 1.5rem 1.5rem;
  overflow-x: hidden;
  overflow-y: auto;
}

.user-simple-layout__content::-webkit-scrollbar {
  width: 0.65rem;
}

.user-simple-layout__content::-webkit-scrollbar-track {
  background: transparent;
}

.user-simple-layout__content::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.65);
  border-radius: 999px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.user-simple-layout__content::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 116, 139, 0.8);
  background-clip: padding-box;
}

:host ::ng-deep .user-simple-layout__profile .dropdown-user {
  list-style: none;
  margin: 0;
}

:host ::ng-deep .user-simple-layout__profile .dropdown-user::marker {
  content: "";
}

@media (max-width: 768px) {
  .user-simple-layout__topbar {
    height: auto;
    align-items: flex-start;
    gap: 1rem;
    padding: 0.9rem 1rem;
  }
  .user-simple-layout__brand {
    gap: 0.75rem;
    flex: 1 1 auto;
  }
  .user-simple-layout__workspace-title {
    font-size: 0.95rem;
  }
  .user-simple-layout__workspace-meta {
    max-width: none;
  }
  .user-simple-layout__logo {
    width: 8.75rem;
  }
  .user-simple-layout__divider {
    height: 2rem;
  }
  .user-simple-layout__profile {
    align-self: center;
  }
  .user-simple-layout__content {
    padding-right: 1rem;
    padding-left: 1rem;
    padding-bottom: 1.5rem;
    padding-top: 0.9rem;
  }
  .user-simple-layout__greeting {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/modules/navigation/layouts/layout-user-simple/layout-user-simple.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;EACA,8IACI;AAAR;;AAIA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,mBAAA;EACA,gCAAA;EACA,8CAAA;AADJ;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AADJ;;AAIA;EACI,cAAA;EACA,YAAA;EACA,YAAA;AADJ;;AAIA;EACI,UAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;AADJ;;AAIA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;EACA,oCAAA;AADJ;;AAIA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADJ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAFJ;;AAKA;EACI,oBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,cAAA;AAFJ;;AAMA;;;;EAII,WAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,kFAAA;AAHJ;;AAMA;;EAEI,yBAAA;AAHJ;;AAMA;;;;;;;;;;EAUI,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;AAHJ;;AAMA;;EAEI,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;EACA,4DAAA;AAHJ;;AAMA;;;;EAII,UAAA;EACA,iGAAA;AAHJ;;AAMA;;;;EAII,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAHJ;;AAMA;;EAEI,oBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;AAHJ;;AAOA;EACI,UAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;AAJJ;;AAOA;EACI,6BAAA;AAJJ;;AAOA;EACI,eAAA;EACA,QAAA;EACA,aAAA;EACA,kCAAA;AAJJ;;AAOA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,+CAAA;EACA,2BAAA;EACA,gCAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,wBAAA;EACA,oBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,uBAAA;EACA,gCAAA;AAJJ;;AAOA;EACI,SAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;;AAOA;;EAEI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;AAJJ;;AAOA;;EAEI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;AAJJ;AAMI;;;EAEI,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;AAHR;;AAOA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;AAJJ;;AAOA;EACI,mBAAA;AAJJ;;AAOA;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,cAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;AAJJ;AAMI;EACI,qBAAA;EACA,4CAAA;AAJR;AAOI;EACI,qBAAA;AALR;;AASA;EACI,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AANJ;;AASA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;AANJ;;AASA;EACI,cAAA;EACA,YAAA;EACA,cAAA;EACA,gGAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AANJ;;AASA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AANJ;AAQI;EACI,cAAA;EACA,eAAA;AANR;;AAUA;EACI,aAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AAPJ;;AAUA;EACI,eAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;AASI;EAEI,mBAAA;EACA,aAAA;AARR;;AAYA;EACI,qBAAA;EACA,mBAAA;EACA,cAAA;AATJ;AAWI;EAEI,mBAAA;AAVR;;AAcA;EACI,cAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;AAXJ;;AAcA;EACI,cAAA;AAXJ;;AAcA;EACI,uBAAA;AAXJ;;AAcA;EACI,qCAAA;EACA,oBAAA;EACA,6BAAA;EACA,4BAAA;AAXJ;;AAcA;EACI,oCAAA;EACA,4BAAA;AAXJ;;AAcA;EACI,gBAAA;EACA,SAAA;AAXJ;;AAcA;EACI,WAAA;AAXJ;;AAcA;EACI;IACI,YAAA;IACA,uBAAA;IACA,SAAA;IACA,oBAAA;EAXN;EAcE;IACI,YAAA;IACA,cAAA;EAZN;EAeE;IACI,kBAAA;EAbN;EAgBE;IACI,eAAA;EAdN;EAiBE;IACI,cAAA;EAfN;EAkBE;IACI,YAAA;EAhBN;EAmBE;IACI,kBAAA;EAjBN;EAoBE;IACI,mBAAA;IACA,kBAAA;IACA,sBAAA;IACA,mBAAA;EAlBN;EAqBE;IACI,aAAA;EAnBN;AACF","sourcesContent":[".user-simple-layout {\n    display: flex;\n    flex-direction: column;\n    height: 100dvh;\n    overflow: hidden;\n    background:\n        radial-gradient(circle at top right, rgba(59, 130, 246, 0.08), transparent 32%),\n        linear-gradient(180deg, #f8fbff 0%, #f1f5f9 100%);\n}\n\n.user-simple-layout__topbar {\n    height: 5.625rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 1.5rem 0 0.9rem;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);\n}\n\n.user-simple-layout__brand {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    min-width: 0;\n}\n\n.user-simple-layout__logo {\n    display: block;\n    width: 10rem;\n    height: auto;\n}\n\n.user-simple-layout__divider {\n    width: 1px;\n    height: 2.4rem;\n    background: #d7e2ef;\n    flex: 0 0 auto;\n}\n\n.user-simple-layout__workspace-meta {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    max-width: clamp(10rem, 28vw, 18rem);\n}\n\n.user-simple-layout__workspace-title {\n    color: #0f2744;\n    font-size: 1rem;\n    font-weight: 700;\n    line-height: 1.2;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.user-simple-layout__profile {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.75rem;\n    color: #475569;\n    font-size: 0.95rem;\n    font-weight: 500;\n    white-space: nowrap;\n}\n\n\n.top-nav-actions {\n    display: flex;\n    align-items: center;\n    gap: 22px;\n}\n\n.user-simple-layout__profile ejs-tooltip {\n    display: inline-flex;\n    align-items: center;\n}\n\n.user-simple-layout__greeting {\n    color: #64748b;\n}\n\n\n.user-simple-layout__profile .top-nav-action-btn,\n.user-simple-layout__profile .top-nav-action-btn.e-btn,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn.e-btn {\n    width: 42px;\n    min-width: 42px;\n    height: 42px;\n    padding: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 0;\n    border-radius: 999px;\n    background: transparent;\n    color: #7b8491;\n    box-shadow: none;\n    line-height: 1;\n    transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease;\n}\n\n.user-simple-layout__profile .top-nav-action-btn.user-simple-layout__nav-icon-button--active,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn.user-simple-layout__nav-icon-button--active {\n    border: 1px solid #cfe3ff;\n}\n\n.user-simple-layout__profile .top-nav-action-btn:hover,\n.user-simple-layout__profile .top-nav-action-btn:focus-visible,\n.user-simple-layout__profile .top-nav-action-btn.user-simple-layout__nav-icon-button--active,\n.user-simple-layout__profile .top-nav-action-btn.e-btn:hover,\n.user-simple-layout__profile .top-nav-action-btn.e-btn:focus-visible,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn:hover,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn:focus-visible,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn.user-simple-layout__nav-icon-button--active,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn.e-btn:hover,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn.e-btn:focus-visible {\n    border-color: #cfe3ff;\n    background: #eef6ff;\n    color: #0066ff;\n    outline: none;\n    box-shadow: none;\n}\n\n.top-nav-svg-icon,\n:host ::ng-deep .user-simple-layout__profile .top-nav-svg-icon {\n    width: 24px;\n    height: 24px;\n    display: block;\n    object-fit: contain;\n    opacity: 0.82;\n    filter: grayscale(1) saturate(0) brightness(0) opacity(0.62);\n}\n\n.top-nav-action-btn:hover .top-nav-svg-icon,\n.top-nav-action-btn:focus-visible .top-nav-svg-icon,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn:hover .top-nav-svg-icon,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn:focus-visible .top-nav-svg-icon {\n    opacity: 1;\n    filter: invert(34%) sepia(96%) saturate(2870%) hue-rotate(207deg) brightness(101%) contrast(104%);\n}\n\n.user-simple-layout__profile .top-nav-action-icon,\n.user-simple-layout__profile .top-nav-action-btn .e-icons,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-icon,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-btn .e-icons {\n    width: 24px;\n    height: 24px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: currentColor;\n    font-size: 24px;\n    line-height: 24px;\n}\n\n.user-simple-layout__nav-feather-icon,\n:host ::ng-deep .user-simple-layout__profile .top-nav-action-icon svg {\n    stroke: currentColor;\n}\n\n:host ::ng-deep .user-simple-layout__nav-feather-icon svg {\n    width: 23px;\n    height: 23px;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n}\n\n\n.user-simple-layout__nav-svg-icon {\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 1.9;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n}\n\n.user-simple-layout__billing-icon {\n    transform: translateY(0.1rem);\n}\n\n.api-key-drawer-backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 1040;\n    background: rgba(15, 23, 42, 0.32);\n}\n\n.api-key-drawer {\n    position: fixed;\n    top: 0;\n    right: 0;\n    z-index: 1041;\n    display: flex;\n    flex-direction: column;\n    width: min(28.75rem, 100vw);\n    height: 100vh;\n    padding: 1.5rem;\n    border-left: 1px solid #e2e8f0;\n    background: #ffffff;\n    box-shadow: -20px 0 48px rgba(15, 23, 42, 0.18);\n    transform: translateX(100%);\n    transition: transform 0.24s ease;\n    pointer-events: none;\n}\n\n.api-key-drawer--open {\n    transform: translateX(0);\n    pointer-events: auto;\n}\n\n.api-key-drawer__header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 1rem;\n    padding-bottom: 1.25rem;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.api-key-drawer__title {\n    margin: 0;\n    color: #0f172a;\n    font-size: 1.15rem;\n    font-weight: 700;\n}\n\n.api-key-drawer__description,\n.api-key-drawer__helper {\n    margin: 0.45rem 0 0;\n    color: #64748b;\n    font-size: 0.86rem;\n    line-height: 1.45;\n}\n\n.api-key-drawer__close,\n.api-key-drawer__edit {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #dbe3ec;\n    background: #ffffff;\n    color: #475569;\n\n    &:hover,\n    &:focus-visible {\n        border-color: #b8c7d7;\n        background: #f8fafc;\n        color: #004d80;\n        outline: none;\n    }\n}\n\n.api-key-drawer__close {\n    width: 2rem;\n    height: 2rem;\n    border-radius: 0.55rem;\n    font-size: 1.25rem;\n    line-height: 1;\n}\n\n.api-key-drawer__content {\n    padding-top: 1.5rem;\n}\n\n.api-key-drawer__section-title {\n    margin: 0 0 1rem;\n    color: #1e293b;\n    font-size: 0.95rem;\n    font-weight: 700;\n}\n\n.api-key-drawer__label {\n    display: block;\n    margin-bottom: 0.4rem;\n    color: #334155;\n    font-size: 0.82rem;\n    font-weight: 700;\n}\n\n.api-key-drawer__input {\n    width: 100%;\n    height: 2.65rem;\n    padding: 0 0.8rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 0.55rem;\n    color: #0f172a;\n    font-size: 0.92rem;\n    outline: none;\n\n    &:focus {\n        border-color: #004d80;\n        box-shadow: 0 0 0 3px rgba(0, 77, 128, 0.12);\n    }\n\n    &[aria-invalid='true'] {\n        border-color: #dc2626;\n    }\n}\n\n.api-key-drawer__error {\n    margin: 0.45rem 0 0;\n    color: #dc2626;\n    font-size: 0.78rem;\n    font-weight: 600;\n}\n\n.api-key-drawer__summary {\n    display: flex;\n    align-items: center;\n    gap: 0.65rem;\n    padding: 0.8rem;\n    border: 1px solid #dbe3ec;\n    border-radius: 0.7rem;\n    background: #f8fafc;\n}\n\n.api-key-drawer__masked-key {\n    flex: 1 1 auto;\n    min-width: 0;\n    color: #0f172a;\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', monospace;\n    font-size: 0.9rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.api-key-drawer__edit {\n    flex: 0 0 auto;\n    width: 2rem;\n    height: 2rem;\n    border-radius: 0.5rem;\n\n    i-feather {\n        width: 0.95rem;\n        height: 0.95rem;\n    }\n}\n\n.api-key-drawer__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.75rem;\n    margin-top: 1.5rem;\n}\n\n.api-key-drawer__button {\n    min-width: 5rem;\n    height: 2.35rem;\n    padding: 0 1rem;\n    border: 1px solid #cbd5e1;\n    border-radius: 0.55rem;\n    background: #ffffff;\n    color: #334155;\n    font-size: 0.86rem;\n    font-weight: 700;\n\n    &:hover,\n    &:focus-visible {\n        background: #f8fafc;\n        outline: none;\n    }\n}\n\n.api-key-drawer__button--primary {\n    border-color: #004d80;\n    background: #004d80;\n    color: #ffffff;\n\n    &:hover,\n    &:focus-visible {\n        background: #003f69;\n    }\n}\n\n.user-simple-layout__content {\n    flex: 1 1 auto;\n    min-height: 0;\n    padding: 1.15rem 1.5rem 1.5rem;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.user-simple-layout__content::-webkit-scrollbar {\n    width: 0.65rem;\n}\n\n.user-simple-layout__content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.user-simple-layout__content::-webkit-scrollbar-thumb {\n    background: rgba(148, 163, 184, 0.65);\n    border-radius: 999px;\n    border: 2px solid transparent;\n    background-clip: padding-box;\n}\n\n.user-simple-layout__content::-webkit-scrollbar-thumb:hover {\n    background: rgba(100, 116, 139, 0.8);\n    background-clip: padding-box;\n}\n\n:host ::ng-deep .user-simple-layout__profile .dropdown-user {\n    list-style: none;\n    margin: 0;\n}\n\n:host ::ng-deep .user-simple-layout__profile .dropdown-user::marker {\n    content: '';\n}\n\n@media (max-width: 768px) {\n    .user-simple-layout__topbar {\n        height: auto;\n        align-items: flex-start;\n        gap: 1rem;\n        padding: 0.9rem 1rem;\n    }\n\n    .user-simple-layout__brand {\n        gap: 0.75rem;\n        flex: 1 1 auto;\n    }\n\n    .user-simple-layout__workspace-title {\n        font-size: 0.95rem;\n    }\n\n    .user-simple-layout__workspace-meta {\n        max-width: none;\n    }\n\n    .user-simple-layout__logo {\n        width: 8.75rem;\n    }\n\n    .user-simple-layout__divider {\n        height: 2rem;\n    }\n\n    .user-simple-layout__profile {\n        align-self: center;\n    }\n\n    .user-simple-layout__content {\n        padding-right: 1rem;\n        padding-left: 1rem;\n        padding-bottom: 1.5rem;\n        padding-top: 0.9rem;\n    }\n\n    .user-simple-layout__greeting {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
